var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-main', [_c('v-responsive', {
    staticClass: "mb-5"
  }, [_c('v-card', {
    attrs: {
      "color": "grey lighten-2",
      "flat": "",
      "tile": ""
    }
  }, [_c('v-row', {
    staticClass: "align-center justify-center"
  }, [_c('v-col', {
    attrs: {
      "cols": "1"
    }
  }), _c('v-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('v-img', {
    staticClass: "mx-auto",
    attrs: {
      "src": require("../assets/logo/app_logo.svg"),
      "max-height": "100px",
      "max-width": "100px"
    }
  })], 1), _c('v-col', [_c('v-card-text', {
    staticClass: "grey--text text--darken-3 text-center text-h4 pt-10"
  }, [_c('strong', {
    staticClass: "black--text"
  }, [_vm._v("Multinet")]), _vm._v(" is visualization tool for networks with attributes associated with the nodes and links. ")])], 1), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  })], 1), _c('v-card-text', [_c('v-img', {
    staticStyle: {
      "margin-left": "50px",
      "margin-right": "50px"
    },
    attrs: {
      "src": require("../assets/multilink-overview.webp"),
      "max-height": "500px"
    }
  })], 1)], 1)], 1), _c('v-container', {
    attrs: {
      "id": "lower-half"
    }
  }, [_c('v-row', {
    staticClass: "text-center"
  }, [_c('v-spacer'), _c('v-col', {
    staticClass: "text-h4 grey--text text--darken-4"
  }, [_vm._v(" Getting Started ")]), _c('v-spacer')], 1), _c('v-row', {
    staticClass: "text-center pb-12"
  }, [_c('v-spacer'), _c('v-col', {
    staticClass: "text-h6 grey--text text--darken-4",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "x-large": ""
    },
    on: {
      "click": _vm.login
    }
  }, [_c('v-icon', {
    attrs: {
      "x-large": ""
    }
  }, [_vm._v(" mdi-upload ")])], 1), _vm._v(" Sign up and upload your own data ")], 1), _c('v-spacer'), _c('v-col', {
    staticClass: "text-h6 grey--text text--darken-4",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-icon', {
    staticClass: "pr-1",
    attrs: {
      "x-large": ""
    }
  }, [_vm._v(" mdi-gamepad-square ")]), _vm._v(" Try a demo below or explore the public workspaces ")], 1), _c('v-spacer'), _c('v-col', {
    staticClass: "text-h6 grey--text text--darken-4",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-dialog', {
    attrs: {
      "width": "500"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var on = _ref.on;
        return [_c('v-btn', _vm._g({
          staticClass: "px-0",
          attrs: {
            "icon": "",
            "x-large": "",
            "min-width": "40px"
          }
        }, on), [_c('v-icon', {
          attrs: {
            "x-large": ""
          }
        }, [_vm._v(" mdi-information ")])], 1)];
      }
    }]),
    model: {
      value: _vm.dialog,
      callback: function ($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c('about-text', {
    on: {
      "toggle": function ($event) {
        _vm.dialog = false;
      }
    }
  })], 1), _vm._v(" Learn more about MultiNet ")], 1), _c('v-spacer')], 1), _c('div', {
    staticClass: "px-6 py-2"
  }, [_c('v-row', {
    staticClass: "px-5 pb-6"
  }, _vm._l(_vm.samples, function (sample) {
    return _c('v-col', {
      key: sample.title,
      attrs: {
        "cols": "4"
      }
    }, [_c('v-hover', {
      scopedSlots: _vm._u([{
        key: "default",
        fn: function (_ref2) {
          var hover = _ref2.hover;
          return [_c('v-card', [_c('v-img', {
            staticClass: "align-end",
            attrs: {
              "height": "250px",
              "src": sample.image
            }
          }, [_c('v-card-title', {
            staticClass: "box-shadow-title"
          }, [_vm._v(" " + _vm._s(sample.title) + " ")])], 1), _c('v-fade-transition', [hover ? _c('v-overlay', {
            attrs: {
              "absolute": "",
              "opacity": ".85"
            }
          }, [_c('div', {
            staticClass: "overlay-text"
          }, [_c('p', [_vm._v(_vm._s(sample.text))]), _c('v-btn', {
            attrs: {
              "color": "primary",
              "href": sample.href,
              "target": "_blank"
            }
          }, [_vm._v(" Open in New Window ")])], 1)]) : _vm._e()], 1)], 1)];
        }
      }], null, true)
    })], 1);
  }), 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }